import { useCallback } from 'react';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { Text } from 'foundations-components/components/Text';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { SpecificUsersAndTeams } from '../SpecificUsersAndTeams';
import { UsersWithInstallAccessTable } from '../../UsersWithInstallAccessDrawer/UsersWithInstallAccessTable';
import { useInstallPermissions } from '../../../contexts/InstallPermissionsContext';
import { InstallPermissionAccessTypes } from '../../../constants/installPermissions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const InstallPermissionOptionDescription = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Text, {
    color: "text-core-subtle",
    typography: "detail-200",
    marginBlockEnd: "0",
    marginBlockStart: "200",
    children: children
  });
};
function InstallPermissionStateContent({
  installPermissionAccessState
}) {
  switch (installPermissionAccessState) {
    case InstallPermissionAccessTypes.SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS:
      return /*#__PURE__*/_jsx(UsersWithInstallAccessTable, {});
    case InstallPermissionAccessTypes.SPECIFIC_USERS_AND_TEAMS:
      return /*#__PURE__*/_jsx(SpecificUsersAndTeams, {});
    default:
      return null;
  }
}
export function InstallPermissionsTile() {
  const {
    installPermissionAccessState,
    setInstallPermissionAccessState
  } = useInstallPermissions();
  const onRadioChange = useCallback(event => {
    setInstallPermissionAccessState(event.target.value);
  }, [setInstallPermissionAccessState]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tile, {
      children: /*#__PURE__*/_jsx(TileSection, {
        children: /*#__PURE__*/_jsxs(ToggleGroup, {
          name: "install-permissions",
          children: [/*#__PURE__*/_jsx(RadioInput, {
            "data-selenium": "install-permissions-admins-radio",
            checked: installPermissionAccessState === InstallPermissionAccessTypes.SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS,
            value: InstallPermissionAccessTypes.SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS,
            onChange: onRadioChange,
            description: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "100",
              marginBlockStart: "200",
              children: [/*#__PURE__*/_jsx(Text, {
                color: "text-core-subtle",
                typography: "detail-200",
                marginBlockEnd: "0",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app-governance-lib.installPermissions.options.default.description"
                })
              }), /*#__PURE__*/_jsx(HelpIcon, {
                title: I18n.text('app-governance-lib.installPermissions.options.default.appMarketplaceAccessTooltip'),
                size: "small"
              })]
            }),
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "200",
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.installPermissions.options.default.title"
              }), /*#__PURE__*/_jsx(Tag, {
                use: "default",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app-governance-lib.installPermissions.options.default.tag"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(RadioInput, {
            "data-selenium": "install-permissions-specific-users-radio",
            value: InstallPermissionAccessTypes.SPECIFIC_USERS_AND_TEAMS,
            checked: installPermissionAccessState === InstallPermissionAccessTypes.SPECIFIC_USERS_AND_TEAMS,
            onChange: onRadioChange,
            description: /*#__PURE__*/_jsx(InstallPermissionOptionDescription, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.installPermissions.options.specificUsers.descriptionWithTeams"
              })
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app-governance-lib.installPermissions.options.specificUsers.titleWithTeams"
            })
          }), /*#__PURE__*/_jsx(RadioInput, {
            "data-selenium": "install-permissions-everyone-radio",
            value: InstallPermissionAccessTypes.EVERYONE,
            checked: installPermissionAccessState === InstallPermissionAccessTypes.EVERYONE,
            onChange: onRadioChange,
            description: /*#__PURE__*/_jsx(InstallPermissionOptionDescription, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.installPermissions.options.everyone.description"
              })
            }),
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "200",
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.installPermissions.options.everyone.title"
              }), /*#__PURE__*/_jsx(Tag, {
                use: "default",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app-governance-lib.installPermissions.options.everyone.tag"
                })
              })]
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      paddingBlock: "200",
      "data-selenium": "install-permissions-sub-content",
      children: /*#__PURE__*/_jsx(InstallPermissionStateContent, {
        installPermissionAccessState: installPermissionAccessState
      })
    })]
  });
}